import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  Grid,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from 'recharts';
import { DetailsContainer, Content, Icon, Divider, Title } from './styles';

const data = [
  { name: 'Page A', uv: 4000, pv: 2400, amt: 2400 },
  { name: 'Page B', uv: 3000, pv: 1398, amt: 2210 },
  { name: 'Page C', uv: 2000, pv: 9800, amt: 2290 }
];

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CardDetailsModal = ({ card, open, onClose }) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      maxWidth="lg"
    >
      <DialogContent>
        <Icon onClick={onClose} color="primary" component="span">
          <CloseIcon />
        </Icon>
        <Content>
          <DetailsContainer>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <Title variant="h5">{card && card.title}</Title>
                <Divider />
                <ResponsiveContainer width={1100} height={400}>
                  <LineChart data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="pv"
                      stroke="#8884d8"
                      activeDot={{ r: 8 }}
                    />
                    <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
                  </LineChart>
                </ResponsiveContainer>
              </Grid>
              <Grid item xs={6}>
                <Title variant="h5">details</Title>
                <Divider />
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>name</TableCell>
                        <TableCell align="right">uv</TableCell>
                        <TableCell align="right">pv</TableCell>
                        <TableCell align="right">amt</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.map(row => (
                        <TableRow key={row.name}>
                          <TableCell component="th" scope="row">
                            {row.name}
                          </TableCell>
                          <TableCell align="right">{row.uv}</TableCell>
                          <TableCell align="right">{row.pv}</TableCell>
                          <TableCell align="right">{row.amt}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </DetailsContainer>
        </Content>
      </DialogContent>
    </Dialog>
  );
};

CardDetailsModal.propTypes = {
  open: PropTypes.bool,
  card: PropTypes.object,
  onClose: PropTypes.func,
  onDelete: PropTypes.func,
};

export default CardDetailsModal;
